import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { TournamentResultVO } from "../../../gamevo/TournamentResultVO";

export class Poker2TourResultDialogProperties extends BasicDialogProperties {
    public tournamentResultVO: TournamentResultVO;
    public functionOk: Function;

    constructor(tournamentResultVO: TournamentResultVO, functionOk: Function = null) {
        super();

        this.functionOk = functionOk;
        this.tournamentResultVO = tournamentResultVO;
    }
}
